
export default {
  DepletionFromMineralReserves: 0,
  DepletionFromMineralResources: 1,
  NetChangeInStockpileBalance: 2,
  InterpretationDrilling: 3,
  MiningApproach: 4,
  NewEstimationParameters: 5,
  NewCOG: 6,
  ClassificationRevision: 7,
  StudyAndAcquisition: 8
}